export const SIDEBAR_MOBILE_WIDTH = 'w-[288px] max-w-[86vw]';
export const SIDEBAR_DESKTOP_EXPANDED_WIDTH = 'w-[264px] shrink-0';
export const SIDEBAR_DESKTOP_COLLAPSED_WIDTH = 'w-14 shrink-0';
export const SIDEBAR_TRANSITION = 'transition-all duration-300 ease-in-out';
export const SIDEBAR_MOBILE_TRANSITION = 'transform transition-transform duration-300 ease-in-out';

export const PROMPT_LIST_DESKTOP_WIDTH = 'w-[320px] 2xl:w-[380px] shrink-0';
export const PROMPT_EDITOR_DESKTOP_WIDTH = 'flex-1 min-w-0 overflow-hidden';

export const PANEL_BORDER_CLASS = 'border-r border-rule';
export const PANEL_BASE_CLASS = 'flex flex-col';

export const LOADER_WRAPPER_CLASS = 'flex-grow flex items-center justify-center';
export const LOADER_TEXT_CLASS = 'text-sm text-graphite';
